const {
  ARICA_PARINACOTA,
  TARAPACA,
  ANTOFAGASTA,
  ATACAMA,
  COQUIMBO,
  VALPARAISO,
  METROPOLITANA,
  OHIGGINS,
  MAULE,
  NUBLE,
  BIOBIO,
  ARAUCANIA,
  LOS_RIOS,
  LOS_LAGOS,
  AYSEN,
  MAGALLANES,
} = require('./regions');

const ARICA = 'Arica';
const CAMARONES = 'Camarones';
const GENERAL_LAGOS = 'General Lagos';
const PUTRE = 'Putre';

const ALTO_HOSPICIO = 'Alto Hospicio';
const CAMINA = 'Camiña';
const COLCHANE = 'Colchane';
const HUARA = 'Huara';
const IQUIQUE = 'Iquique';
const PICA = 'Pica';
const POZO_ALMONTE = 'Pozo Almonte';

const C_ANTOFAGASTA = 'Antofagasta';
const CALAMA = 'Calama';
const MARIA_ELENA = 'María Elena';
const MEJILLONES = 'Mejillones';
const OLLAGUE = 'Ollagüe';
const SAN_PEDRO_ATACAMA = 'San Pedro de Atacama';
const SIERRA_GORDA = 'Sierra Gorda';
const TALTAL = 'Taltal';
const TOCOPILLA = 'Tocopilla';

const ALTO_DEL_CARMEN = 'Alto del Carmen';
const CALDERA = 'Caldera';
const CHANARAL = 'Chañaral';
const COPIAPO = 'Copiapó';
const DIEGO_DE_ALMAGRO = 'Diego de Almagro';
const FREIRINA = 'Freirina';
const HUASCO = 'Huasco';
const TIERRA_AMARILLA = 'Tierra Amarilla';
const VALLENAR = 'Vallenar';

const ANDACOLLO = 'Andacollo';
const CANELA = 'Canela';
const COMBARBALA = 'Combarbalá';
const C_COQUIMBO = 'Coquimbo';
const ILLAPEL = 'Illapel';
const LA_HIGUERA = 'La Higuera';
const LA_SERENA = 'La Serena';
const LOS_VILOS = 'Los Vilos';
const MONTE_PATRIA = 'Monte Patria';
const OVALLE = 'Ovalle';
const PAIHUANO = 'Paihuano';
const PUNITAQUI = 'Punitaqui';
const RIO_HURTADO = 'Río Hurtado';
const SALAMANCA = 'Salamanca';
const VICUNA = 'Vicuña';

const ALGARROBO = 'Algarrobo';
const CABILDO = 'Cabildo';
const CALERA = 'Calera';
const CALLE_LARGA = 'Calle Larga';
const CARTAGENA = 'Cartagena';
const CASABLANCA = 'Casablanca';
const CATEMU = 'Catemu';
const CONCON = 'Concón';
const EL_QUISCO = 'El Quisco';
const EL_TABO = 'El Tabo';
const HIJUELAS = 'Hijuelas';
const ISLA_DE_PASCUA = 'Isla de Pascua';
const JUAN_FERNANDEZ = 'Juan Fernández';
const LA_CRUZ = 'La Cruz';
const LA_LIGUA = 'La Ligua';
const LIMACHE = 'Limache';
const LLAILLAY = 'Llaillay';
const LOS_ANDES = 'Los Andes';
const NOGALES = 'Nogales';
const OLMUE = 'Olmué';
const PANQUEHUE = 'Panquehue';
const PAPUDO = 'Papudo';
const PETORCA = 'Petorca';
const PUCHUNCAVI = 'Puchuncaví';
const PUTAENDO = 'Putaendo';
const QUILLOTA = 'Quillota';
const QUILPUE = 'Quilpué';
const QUINTERO = 'Quintero';
const RINCONADA = 'Rinconada';
const SAN_ANTONIO = 'San Antonio';
const SAN_ESTEBAN = 'San Esteban';
const SAN_FELIPE = 'San Felipe';
const SANTA_MARIA = 'Santa María';
const SANTO_DOMINGO = 'Santo Domingo';
const C_VALPARAISO = 'Valparaíso';
const VILLA_ALEMANA = 'Villa Alemana';
const VINA_DEL_MAR = 'Viña del Mar';
const ZAPALLAR = 'Zapallar';

const ALHUE = 'Alhué';
const BUIN = 'Buin';
const CALERA_DE_TANGO = 'Calera de Tango';
const CERRILLOS = 'Cerrillos';
const CERRO_NAVIA = 'Cerro Navia';
const COLINA = 'Colina';
const CONCHALI = 'Conchalí';
const CURACAVI = 'Curacaví';
const EL_BOSQUE = 'El Bosque';
const EL_MONTE = 'El Monte';
const ESTACION_CENTRAL = 'Estación Central';
const HUECHURABA = 'Huechuraba';
const INDEPENDENCIA = 'Independencia';
const ISLA_DE_MAIPO = 'Isla de Maipo';
const LA_CISTERNA = 'La Cisterna';
const LA_FLORIDA = 'La Florida';
const LA_GRANJA = 'La Granja';
const LA_PINTANA = 'La Pintana';
const LA_REINA = 'La Reina';
const LAMPA = 'Lampa';
const LAS_CONDES = 'Las Condes';
const LO_BARNECHEA = 'Lo Barnechea';
const LO_ESPEJO = 'Lo Espejo';
const LO_PRADO = 'Lo Prado';
const MACUL = 'Macul';
const MAIPU = 'Maipú';
const MARIA_PINTO = 'María Pinto';
const MELIPILLA = 'Melipilla';
const NUNOA = 'Ñuñoa';
const PADRE_HURTADO = 'Padre Hurtado';
const PAINE = 'Paine';
const PEDRO_AGUIRRE_CERDA = 'Pedro Aguirre Cerda';
const PENAFLOR = 'Peñaflor';
const PENALOLEN = 'Peñalolén';
const PIRQUE = 'Pirque';
const PROVIDENCIA = 'Providencia';
const PUDAHUEL = 'Pudahuel';
const PUENTE_ALTO = 'Puente Alto';
const QUILICURA = 'Quilicura';
const QUINTA_NORMAL = 'Quinta Normal';
const RECOLETA = 'Recoleta';
const RENCA = 'Renca';
const SAN_BERNARDO = 'San Bernardo';
const SAN_JOAQUIN = 'San Joaquín';
const SAN_JOSE_DE_MAIPO = 'San José de Maipo';
const SAN_MIGUEL = 'San Miguel';
const SAN_PEDRO = 'San Pedro';
const SAN_RAMON = 'San Ramón';
const SANTIAGO = 'Santiago';
const TALAGANTE = 'Talagante';
const TIL_TIL = 'Til Til';
const VITACURA = 'Vitacura';

const CHEPICA = 'Chépica';
const CHIMBARONGO = 'Chimbarongo';
const CODEGUA = 'Codegua';
const COINCO = 'Coinco';
const COLTAUCO = 'Coltauco';
const DONIHUE = 'Doñihue';
const GRANEROS = 'Graneros';
const LA_ESTRELLA = 'La Estrella';
const LAS_CABRAS = 'Las Cabras';
const LITUECHE = 'Litueche';
const LOLOL = 'Lolol';
const MACHALI = 'Machalí';
const MALLOA = 'Malloa';
const MARCHIHUE = 'Marchihue';
const MOSTAZAL = 'Mostazal';
const NANCAGUA = 'Nancagua';
const NAVIDAD = 'Navidad';
const OLIVAR = 'Olivar';
const PALMILLA = 'Palmilla';
const PAREDONES = 'Paredones';
const PERALILLO = 'Peralillo';
const PEUMO = 'Peumo';
const PICHIDEGUA = 'Pichidegua';
const PICHILEMU = 'Pichilemu';
const PLACILLA = 'Placilla';
const PUMANQUE = 'Pumanque';
const QUINTA_DE_TILCOCO = 'Quinta de Tilcoco';
const RANCAGUA = 'Rancagua';
const RENGO = 'Rengo';
const REQUINOA = 'Requínoa';
const SAN_FERNANDO = 'San Fernando';
const SAN_VICENTE = 'San Vicente';
const SANTA_CRUZ = 'Santa Cruz';

const CAUQUENES = 'Cauquenes';
const CHANCO = 'Chanco';
const COLBUN = 'Colbún';
const CONSTITUCION = 'Constitución';
const CUREPTO = 'Curepto';
const CURICO = 'Curicó';
const EMPEDRADO = 'Empedrado';
const HUALANE = 'Hualañé';
const LICANTEN = 'Licantén';
const LINARES = 'Linares';
const LONGAVI = 'Longaví';
const C_MAULE = 'Maule';
const MOLINA = 'Molina';
const PARRAL = 'Parral';
const PELARCO = 'Pelarco';
const PELLUHUE = 'Pelluhue';
const PENCAHUE = 'Pencahue';
const RAUCO = 'Rauco';
const RETIRO = 'Retiro';
const RIO_CLARO = 'Río Claro';
const ROMERAL = 'Romeral';
const SAGRADA_FAMILIA = 'Sagrada Familia';
const SAN_CLEMENTE = 'San Clemente';
const SAN_JAVIER = 'San Javier';
const SAN_RAFAEL = 'San Rafael';
const TALCA = 'Talca';
const TENO = 'Teno';
const VICHUQUEN = 'Vichuquén';
const VILLA_ALEGRE = 'Villa Alegre';
const YERBAS_BUENAS = 'Yerbas Buenas';

const BULNES = 'Bulnes';
const CHILLAN = 'Chillán';
const CHILLAN_VIEJO = 'Chillán Viejo';
const COBQUECURA = 'Cobquecura';
const COELEMU = 'Coelemu';
const COIHUECO = 'Coihueco';
const EL_CARMEN = 'El Carmen';
const NINHUE = 'Ninhue';
const NIQUEN = 'Ñiquén';
const PEMUCO = 'Pemuco';
const PINTO = 'Pinto';
const PORTEZUELO = 'Portezuelo';
const QUILLON = 'Quillón';
const QUIRIHUE = 'Quirihue';
const RANQUIL = 'Ránquil';
const SAN_CARLOS = 'San Carlos';
const SAN_FABIAN = 'San Fabián';
const SAN_IGNACIO = 'San Ignacio';
const SAN_NICOLAS = 'San Nicolás';
const TREGUACO = 'Treguaco';
const YUNGAY = 'Yungay';

const ALTO_BIOBIO = 'Alto Biobío';
const ANTUCO = 'Antuco';
const ARAUCO = 'Arauco';
const CABRERO = 'Cabrero';
const CANETE = 'Cañete';
const CHIGUAYANTE = 'Chiguayante';
const CONCEPCION = 'Concepción';
const CONTULMO = 'Contulmo';
const CORONEL = 'Coronel';
const CURANILAHUE = 'Curanilahue';
const FLORIDA = 'Florida';
const HUALPEN = 'Hualpén';
const HUALQUI = 'Hualqui';
const LAJA = 'Laja';
const LEBU = 'Lebu';
const LOS_ALAMOS = 'Los Álamos';
const LOS_ANGELES = 'Los Ángeles';
const LOTA = 'Lota';
const MULCHEN = 'Mulchén';
const NACIMIENTO = 'Nacimiento';
const NEGRETE = 'Negrete';
const PENCO = 'Penco';
const QUILACO = 'Quilaco';
const QUILLECO = 'Quilleco';
const SAN_PEDRO_DE_LA_PAZ = 'San Pedro de la Paz';
const SAN_ROSENDO = 'San Rosendo';
const SANTA_BARBARA = 'Santa Bárbara';
const SANTA_JUANA = 'Santa Juana';
const TALCAHUANO = 'Talcahuano';
const TIRUA = 'Tirúa';
const TOME = 'Tomé';
const TUCAPEL = 'Tucapel';
const YUMBEL = 'Yumbel';

const ANGOL = 'Angol';
const CARAHUE = 'Carahue';
const CHOLCHOL = 'Cholchol';
const COLLIPULLI = 'Collipulli';
const CUNCO = 'Cunco';
const CURACAUTIN = 'Curacautín';
const CURARREHUE = 'Curarrehue';
const ERCILLA = 'Ercilla';
const FREIRE = 'Freire';
const GALVARINO = 'Galvarino';
const GORBEA = 'Gorbea';
const LAUTARO = 'Lautaro';
const LONCOCHE = 'Loncoche';
const LONQUIMAY = 'Lonquimay';
const LOS_SAUCES = 'Los Sauces';
const LUMACO = 'Lumaco';
const MELIPEUCO = 'Melipeuco';
const NUEVA_IMPERIAL = 'Nueva Imperial';
const PADRE_LAS_CASAS = 'Padre las Casas';
const PERQUENCO = 'Perquenco';
const PITRUFQUEN = 'Pitrufquén';
const PUCON = 'Pucón';
const PUREN = 'Purén';
const RENAICO = 'Renaico';
const SAAVEDRA = 'Saavedra';
const TEMUCO = 'Temuco';
const TEODORO_SCHMIDT = 'Teodoro Schmidt';
const TOLTEN = 'Toltén';
const TRAIGUEN = 'Traiguén';
const VICTORIA = 'Victoria';
const VILCUN = 'Vilcún';
const VILLARRICA = 'Villarrica';

const CORRAL = 'Corral';
const FUTRONO = 'Futrono';
const LA_UNION = 'La Unión';
const LAGO_RANCO = 'Lago Ranco';
const LANCO = 'Lanco';
const C_LOS_LAGOS = 'Los Lagos';
const MAFIL = 'Máfil';
const MARIQUINA = 'Mariquina';
const PAILLACO = 'Paillaco';
const PANGUIPULLI = 'Panguipulli';
const RIO_BUENO = 'Río Bueno';
const VALDIVIA = 'Valdivia';

const ANCUD = 'Ancud';
const CALBUCO = 'Calbuco';
const CASTRO = 'Castro';
const CHAITEN = 'Chaitén';
const CHONCHI = 'Chonchi';
const COCHAMO = 'Cochamó';
const CURACO_DE_VELEZ = 'Curaco de Vélez';
const DALCAHUE = 'Dalcahue';
const FRESIA = 'Fresia';
const FRUTILLAR = 'Frutillar';
const FUTALEUFU = 'Futaleufú';
const HUALAIHUE = 'Hualaihué';
const LLANQUIHUE = 'Llanquihue';
const LOS_MUERMOS = 'Los Muermos';
const MAULLIN = 'Maullín';
const OSORNO = 'Osorno';
const PALENA = 'Palena';
const PUERTO_MONTT = 'Puerto Montt';
const PUERTO_OCTAY = 'Puerto Octay';
const PUERTO_VARAS = 'Puerto Varas';
const PUQUELDON = 'Puqueldón';
const PURRANQUE = 'Purranque';
const PUYEHUE = 'Puyehue';
const QUEILEN = 'Queilén';
const QUELLON = 'Quellón';
const QUEMCHI = 'Quemchi';
const QUINCHAO = 'Quinchao';
const RIO_NEGRO = 'Río Negro';
const SAN_JUAN_DE_LA_COSTA = 'San Juan de la Costa';
const SAN_PABLO = 'San Pablo';

const C_AYSEN = 'Aysén';
const CHILE_CHICO = 'Chile Chico';
const CISNES = 'Cisnes';
const COCHRANE = 'Cochrane';
const COYHAIQUE = 'Coyhaique';
const GUAITECAS = 'Guaitecas';
const LAGO_VERDE = 'Lago Verde';
const C_OHIGGINS = "O'Higgins";
const RIO_IBANEZ = 'Río Ibáñez';
const TORTEL = 'Tortel';

const ANTARTICA = 'Antártica';
const CABO_DE_HORNOS = 'Cabo de Hornos';
const LAGUNA_BLANCA = 'Laguna Blanca';
const NATALES = 'Natales';
const PORVENIR = 'Porvenir';
const PRIMAVERA = 'Primavera';
const PUNTA_ARENAS = 'Punta Arenas';
const RIO_VERDE = 'Río Verde';
const SAN_GREGORIO = 'San Gregorio';
const TIMAUKEL = 'Timaukel';
const TORRES_DEL_PAINE = 'Torres del Paine';

const getCommunesByRegion = (region) => {
  switch (region) {
    case ARICA_PARINACOTA:
      return [ARICA, CAMARONES, GENERAL_LAGOS, PUTRE].sort();
    case TARAPACA:
      return [ALTO_HOSPICIO, CAMINA, COLCHANE, HUARA, IQUIQUE, PICA, POZO_ALMONTE].sort();
    case ANTOFAGASTA:
      return [
        C_ANTOFAGASTA, CALAMA, MARIA_ELENA, MEJILLONES, OLLAGUE,
        SAN_PEDRO_ATACAMA, SIERRA_GORDA, TALTAL, TOCOPILLA,
      ].sort();
    case ATACAMA:
      return [
        ALTO_DEL_CARMEN, CALDERA, CHANARAL, COPIAPO, DIEGO_DE_ALMAGRO,
        FREIRINA, HUASCO, TIERRA_AMARILLA, VALLENAR,
      ].sort();
    case COQUIMBO:
      return [
        ANDACOLLO, CANELA, COMBARBALA, C_COQUIMBO, ILLAPEL, LA_HIGUERA,
        LA_SERENA, LOS_VILOS, MONTE_PATRIA, OVALLE, PAIHUANO, PUNITAQUI,
        RIO_HURTADO, SALAMANCA, VICUNA,
      ].sort();
    case VALPARAISO:
      return [
        ALGARROBO, CABILDO, CALERA, CALLE_LARGA, CARTAGENA, CASABLANCA,
        CATEMU, CONCON, EL_QUISCO, EL_TABO, HIJUELAS, ISLA_DE_PASCUA,
        JUAN_FERNANDEZ, LA_CRUZ, LA_LIGUA, LIMACHE, LLAILLAY, LOS_ANDES,
        NOGALES, OLMUE, PANQUEHUE, PAPUDO, PETORCA, PUCHUNCAVI, PUTAENDO,
        QUILLOTA, QUILPUE, QUINTERO, RINCONADA, SAN_ANTONIO, SAN_ESTEBAN,
        SAN_FELIPE, SANTA_MARIA, SANTO_DOMINGO, C_VALPARAISO, VILLA_ALEMANA,
        VINA_DEL_MAR, ZAPALLAR,
      ].sort();
    case METROPOLITANA:
      return [
        ALHUE, BUIN, CALERA_DE_TANGO, CERRILLOS, CERRO_NAVIA, COLINA,
        CONCHALI, CURACAVI, EL_BOSQUE, EL_MONTE, ESTACION_CENTRAL,
        HUECHURABA, INDEPENDENCIA, ISLA_DE_MAIPO, LA_CISTERNA, LA_FLORIDA,
        LA_GRANJA, LA_PINTANA, LA_REINA, LAMPA, LAS_CONDES, LO_BARNECHEA,
        LO_ESPEJO, LO_PRADO, MACUL, MAIPU, MARIA_PINTO, MELIPILLA, NUNOA,
        PADRE_HURTADO, PAINE, PEDRO_AGUIRRE_CERDA, PENAFLOR, PENALOLEN,
        PIRQUE, PROVIDENCIA, PUDAHUEL, PUENTE_ALTO, QUILICURA, QUINTA_NORMAL,
        RECOLETA, RENCA, SAN_BERNARDO, SAN_JOAQUIN, SAN_JOSE_DE_MAIPO,
        SAN_MIGUEL, SAN_PEDRO, SAN_RAMON, SANTIAGO, TALAGANTE, TIL_TIL,
        VITACURA,
      ].sort();
    case OHIGGINS:
      return [
        CHEPICA, CHIMBARONGO, CODEGUA, COINCO, COLTAUCO, DONIHUE, GRANEROS,
        LA_ESTRELLA, LAS_CABRAS, LITUECHE, LOLOL, MACHALI, MALLOA, MARCHIHUE,
        MOSTAZAL, NANCAGUA, NAVIDAD, OLIVAR, PALMILLA, PAREDONES, PERALILLO,
        PEUMO, PICHIDEGUA, PICHILEMU, PLACILLA, PUMANQUE, QUINTA_DE_TILCOCO,
        RANCAGUA, RENGO, REQUINOA, SAN_FERNANDO, SAN_VICENTE, SANTA_CRUZ,
      ].sort();
    case MAULE:
      return [
        CAUQUENES, CHANCO, COLBUN, CONSTITUCION, CUREPTO, CURICO, EMPEDRADO,
        HUALANE, LICANTEN, LINARES, LONGAVI, C_MAULE, MOLINA, PARRAL, PELARCO,
        PELLUHUE, PENCAHUE, RAUCO, RETIRO, RIO_CLARO, ROMERAL, SAGRADA_FAMILIA,
        SAN_CLEMENTE, SAN_JAVIER, SAN_RAFAEL, TALCA, TENO, VICHUQUEN,
        VILLA_ALEGRE, YERBAS_BUENAS,
      ].sort();
    case NUBLE:
      return [
        BULNES, CHILLAN, CHILLAN_VIEJO, COBQUECURA, COELEMU, COIHUECO,
        EL_CARMEN, NINHUE, NIQUEN, PEMUCO, PINTO, PORTEZUELO, QUILLON,
        QUIRIHUE, RANQUIL, SAN_CARLOS, SAN_FABIAN, SAN_IGNACIO, SAN_NICOLAS,
        TREGUACO, YUNGAY,
      ].sort();
    case BIOBIO:
      return [
        ALTO_BIOBIO, ANTUCO, ARAUCO, CABRERO, CANETE, CHIGUAYANTE, CONCEPCION,
        CONTULMO, CORONEL, CURANILAHUE, FLORIDA, HUALPEN, HUALQUI, LAJA, LEBU,
        LOS_ALAMOS, LOS_ANGELES, LOTA, MULCHEN, NACIMIENTO, NEGRETE, PENCO,
        QUILACO, QUILLECO, SAN_PEDRO_DE_LA_PAZ, SAN_ROSENDO, SANTA_BARBARA,
        SANTA_JUANA, TALCAHUANO, TIRUA, TOME, TUCAPEL, YUMBEL,
      ].sort();
    case ARAUCANIA:
      return [
        ANGOL, CARAHUE, CHOLCHOL, COLLIPULLI, CUNCO, CURACAUTIN, CURARREHUE,
        ERCILLA, FREIRE, GALVARINO, GORBEA, LAUTARO, LONCOCHE, LONQUIMAY,
        LOS_SAUCES, LUMACO, MELIPEUCO, NUEVA_IMPERIAL, PADRE_LAS_CASAS,
        PERQUENCO, PITRUFQUEN, PUCON, PUREN, RENAICO, SAAVEDRA, TEMUCO,
        TEODORO_SCHMIDT, TOLTEN, TRAIGUEN, VICTORIA, VILCUN, VILLARRICA,
      ].sort();
    case LOS_RIOS:
      return [
        CORRAL, FUTRONO, LA_UNION, LAGO_RANCO, LANCO, C_LOS_LAGOS, MAFIL,
        MARIQUINA, PAILLACO, PANGUIPULLI, RIO_BUENO, VALDIVIA,
      ].sort();
    case LOS_LAGOS:
      return [
        ANCUD, CALBUCO, CASTRO, CHAITEN, CHONCHI, COCHAMO, CURACO_DE_VELEZ,
        DALCAHUE, FRESIA, FRUTILLAR, FUTALEUFU, HUALAIHUE, LLANQUIHUE,
        LOS_MUERMOS, MAULLIN, OSORNO, PALENA, PUERTO_MONTT, PUERTO_OCTAY,
        PUERTO_VARAS, PUQUELDON, PURRANQUE, PUYEHUE, QUEILEN, QUELLON,
        QUEMCHI, QUINCHAO, RIO_NEGRO, SAN_JUAN_DE_LA_COSTA, SAN_PABLO,
      ].sort();
    case AYSEN:
      return [
        C_AYSEN, CHILE_CHICO, CISNES, COCHRANE, COYHAIQUE, GUAITECAS,
        LAGO_VERDE, C_OHIGGINS, RIO_IBANEZ, TORTEL,
      ].sort();
    case MAGALLANES:
      return [
        ANTARTICA, CABO_DE_HORNOS, LAGUNA_BLANCA, NATALES, PORVENIR,
        PRIMAVERA, PUNTA_ARENAS, RIO_VERDE, SAN_GREGORIO, TIMAUKEL,
        TORRES_DEL_PAINE,
      ].sort();
    default:
      return [];
  }
};

module.exports = {
  getCommunesByRegion,
};
